import * as React from 'react';
import { Dispatch } from 'redux';
import './Login.less';
import { Form, Row, Col, Button, Input, message } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { FormComponentProps } from 'antd/lib/form';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import { ReduxStoreModel } from "src/redux/ReduxModel";
import UserAction, { updateUserError } from "src/redux/UserActions";
import LoginDTO from "src/models/account/LoginDTO";
import { UserState } from "src/redux/UserReducer";
import FullscreenApi from "src/utils/FullscreenHelper";
import RoleRedirect from "src/utils/RoleRedirect";
import { ConstantState } from "src/redux/ConstantReducer";
import DebugUtil from "src/utils/DebugUtil";
import { ConfigState } from "src/redux/ConfigReducer";
import ConfigAction from "src/redux/ConfigActions";
import Languages from "src/constants/Languages";
import CookieConsent from 'react-cookie-consent-notification';
const logo = require('src/assets/branding/logo.png');
const classlinkLogo = require('src/assets/branding/60182f5c9e9d2a1f6fead710_classlink-icon-symbol-large.png');

interface LoginProps extends PageProps<{}>, LocalizeContextProps, FormComponentProps {
    // From Redux
    User: UserState;
    Constants: ConstantState;
    Config: ConfigState;
    login: (loginModel: LoginDTO) => Promise<boolean>;
    updateUserError: (msg: string) => void;
    clearPreviousLocation: () => void;
}

class Login extends React.Component<LoginProps> {
    constructor(props: LoginProps) {
        super(props);
        bindAllOfThis(this, Login.prototype);
    }

    componentWillMount() {
        this.checkUserLogin(this.props);
    }
    componentDidMount(){
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let clientId  = parseInt(params.get('clientId'));
        let ref = params.get('ref');
        if(ref === 'afl'){
            document.getElementById("cleverButton").style.display = "none";
        }else{
            document.getElementById("registerButton").style.display = "none";
        }
    }

    componentWillReceiveProps(nextProps: LoginProps) {
        if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== "") {
            message.error(this.props.translate(nextProps.User.errorMsg));
            this.props.updateUserError("");
        }

        this.checkUserLogin(nextProps);
    }


    private handleLogin(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        // Prevent crushing the login button
        if (this.props.User.state === "loading") {
            return;
        }

        this.props.form.validateFields((errors, values: LoginDTO) => {
            // Make sure all fields are filled out
            if (!errors) {
                // Fire the login request
                if (!DebugUtil.isDebugEnabled()) {
                    FullscreenApi.RequestFullscreen(document.body);
                }

                this.props.login(values);
            }
        });
    }

    private checkUserLogin(props: LoginProps) {
        if (props.User.state === "finished" && props.Constants.state === "finished") {
            // User is logged in and can be directed to either their homepage, or a redirect page if one is set
            // JB: This will set the language whenever the login page is rendered
            if (this.props.User.cultureCode != null) {
                let language = Languages.FindByCode(this.props.User.cultureCode);
                this.props.setActiveLanguage(language.code);
            }

            let route = RoleRedirect.GetRoleRoute(props.User.roleID, props.User.gradeId);
            if (this.props.Config.previousLocation != null) {
                route = this.props.Config.previousLocation;
                this.props.clearPreviousLocation();
            }

            // With this, we can skip the rendering cost of the login page and just send the user to the proper page
            // Set push to false to remove '/login' from the users history
            return props.history.replace(route);
        }
    }

    render() {
        return <div>
            <Row type="flex" justify="center">
                <Col xs={22} sm={22} md={18} lg={14} xl={11} className="login-form">
                    <Link to={Routes.BASE_ROUTE} className="logo" tabIndex={-1}>
                        <img src={logo} alt="Kuder Galaxy" height="100%" width="100%" tabIndex={-1} />
                    </Link>
                    <Form hideRequiredMark onSubmit={this.handleLogin}>
                        <h3><Translate id={"account.login.header1"} /></h3>
                        <Form.Item>
                            <label className="screen-reader-hidden" htmlFor="email"><Translate id="account.login.formItem1" /></label>
                            {
                                this.props.form.getFieldDecorator('email',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.translate("admin.common.requiredRule")
                                                    .toString()
                                            },
                                            {
                                                pattern: /^.+\@.+\..+$/,
                                                message: this.props.translate("admin.common.emailRule").toString()
                                            }
                                        ]
                                    })
                                    (<Input tabIndex={1} size="large" aria-label={this.props
                                        .translate("account.login.formItem1")
                                        .toString()} placeholder={this.props.translate("account.login.formItem1")
                                            .toString()} />)
                            }
                        </Form.Item>
                        <Form.Item>
                            <label className="screen-reader-hidden" htmlFor="password"><Translate id="account.login.formItem2" /></label>
                            {
                                this.props.form.getFieldDecorator('password',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.translate("admin.common.requiredRule")
                                                    .toString()
                                            }
                                        ]
                                    })
                                    (<Input tabIndex={1} size="large" aria-label={this.props
                                        .translate("account.login.formItem2")
                                        .toString()} placeholder={this.props.translate("account.login.formItem2")
                                            .toString()} type="password" />)
                            }
                        </Form.Item>
                        <Form.Item>
                            <Button tabIndex={1} loading={this.props.User.state === "loading"} size="large" type="primary" htmlType="submit">
                                {
                                    this.props.User.state !== "loading" &&
                                    this.props.translate("account.login.loginButton")
                                }
                            </Button>
                            <Button id="registerButton" tabIndex={1} loading={this.props.User.state === "loading"} size="large"  type="primary" onClick={registerLink}>
                                {
                                    this.props.User.state !== "loading" &&
                                    this.props.translate("account.register.registerButton")
                                }
                            </Button>
                        </Form.Item>
                        <div className="ant-row ant-form-item" id="cleverButton">
                            <div className="ant-form-item-control-wrapper">
                                <div className="clever-login-container">
                                    <a href="#" onClick={cleverLink} className="clever-btn">
                                        <span className="clever-c">C</span>
                                        <span className="clever-btn-text">Log in with Clever</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="ant-row ant-form-item" id="classLinkButton">
                            <div className="ant-form-item-control-wrapper">
                                <div className="classlink-login-container">
                                    <a href="#" onClick={classLinkLink} className="classlink-btn">
                                        <span className="classlink-c"><img src={classlinkLogo} alt="ClassLink" height="100%" width="100%" /></span>
                                        <span className="classlink-btn-text">Log in with ClassLink</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </Form>
                    <br />
                    <Link hidden={true} tabIndex={1} to={Routes.REGISTER}><Translate id={"account.login.registerLink"} /></Link>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Link tabIndex={1} to={Routes.FORGOT_PASSWORD}><Translate id={"account.login.forgotPassword"} /></Link>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Link tabIndex={1} to={Routes.PARENTS_HOME}><Translate id={"public.parents.link"} /></Link>
                </Col>
            </Row>

            <div className="cookie-app">
                <CookieConsent
                    background={'#004A86'}
                    bottomPosition={true}
                    buttonText={this.props.translate("account.login.iAgree")}
                    color={'#fff'}
                    padding={20}>
                    {this.props.translate("account.login.cookiePopContent")}
               </CookieConsent>
            </div>;
        </div>;
    }
}

function cleverLink() {
    var link = "https://clever.com/oauth/instant-login?client_id=" + cleverClientId + "&district_id=";
    window.location.href = link;
}

function classLinkLink() {
    var host = window.location.host;
    var protocol = window.location.protocol;
    var redirect_uri = encodeURIComponent(protocol + "//" + host + "/oauth/classlink/");
    var link = `https://launchpad.classlink.com/oauth2/v2/auth?scope=profile,oneroster,openid&redirect_uri=${redirect_uri}&response_type=code&client_id=${classLinkClientId}`;
    window.location.href = link;
}

function registerLink() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let clientId  = parseInt(params.get('clientId'));
    var originLink = window.location.origin ;
    var link = originLink + "/register-afl?clientId=" + clientId;
    window.location.href = link;
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        login: (loginModel: LoginDTO) => UserAction.Login(dispatch, loginModel),
        updateUserError: (msg: string) => updateUserError(dispatch, msg),
        clearPreviousLocation: () => ConfigAction.SetPreviousLocation(dispatch, null),
    });
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User,
        Constants: state.Constants,
        Config: state.Config,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Form.create()(Login)));



// WEBPACK FOOTER //
// ./src/pages/account/Login.tsx